import instance from './Api';

const getUserLogs = () => instance.get(`/userlog`);

export default {
  getUserLogs,
};
